/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UploadedSavedFilmDto } from '../models/UploadedSavedFilmDto';
import { request as __request } from '../core/request';

export class SavedFilmsService {

    /**
     * @param requestBody 
     * @returns UploadedSavedFilmDto OK
     * @throws ApiError
     */
    public static async uploadSavedFilm(
requestBody?: any,
): Promise<UploadedSavedFilmDto> {
        const result = await __request({
            method: 'POST',
            path: `/api/SavedFilms`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param filmId 
     * @returns any OK
     * @throws ApiError
     */
    public static async downloadSavedFilm(
filmId: string,
): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/api/SavedFilms/${filmId}/download`,
        });
        return result.body;
    }

    /**
     * @param filmId 
     * @returns UploadedSavedFilmDto OK
     * @throws ApiError
     */
    public static async getSavedFilmInfo(
filmId: string,
): Promise<UploadedSavedFilmDto> {
        const result = await __request({
            method: 'GET',
            path: `/api/SavedFilms/${filmId}`,
        });
        return result.body;
    }

}